import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

/**
 * Componente FormTitle
 *
 * Título estilizado basado en Typography de MUI, utilizado para encabezados de formularios.
 *
 * @component
 * @param {object} props - Props del componente.
 * @param {string} [props.fontFamily] - Familia de fuente utilizada.
 * @param {number} [props.fontWeight] - Peso de la fuente.
 * @param {string} [props.color] - Color del texto.
 * @param {number} [props.fontSize] - Tamaño de la fuente.
 * @param {number} [props.paddingBottom] - Espaciado inferior.
 * @example
 * <FormTitle>Mi título</FormTitle>
 */

export const FormTitle = styled(Typography)({
  fontFamily: 'Roboto',
  fontWeight: 500,
  color: '#0E335C',
  fontSize: 14,
  paddingBottom: 0
});

export default FormTitle;
